import * as yup from 'yup';

export const buyNowWithBidsSchema = yup.object().shape({
  duration: yup.string().required(),
  amount: yup
    .string()
    .test({
      name: 'amount',
      test: (value, context) => {
        const reservePrice = context.options.context?.reservePrice;
        const bestBidForListing = context.options.context?.bestBidForListing;
        const balance = context.options.context?.balance;

        if (!value) {
          return context.createError({
            type: 'CUSTOM',
            message: 'Required'
          });
        }

        if (+value < +reservePrice) {
          return context.createError({
            type: 'CUSTOM',
            message: 'Each bid must be at least as big as the reserve amount'
          });
        }

        if (+value < +bestBidForListing) {
          return context.createError({
            type: 'CUSTOM',
            message: 'New bids must be larger than the last'
          });
        }

        if (+value > +balance) {
          return context.createError({
            type: 'CUSTOM',
            message: 'Insufficient balance'
          });
        }

        return true;
      }
    })
    .required(),
  token: yup
    .object()
    .shape({
      contractAddress: yup.string().required(),
      name: yup.string().required(),
      symbol: yup.string().required(),
      decimals: yup.number().required()
    })
    .required()
});
